<template>
  <div>
    <ApolloQuery
      :query="require('../graphql/ObraServico.gql')"
      :clientId="client"
      :variables="{ entidade, id }"
      :update="data => {
        switch(data.obraServico.situacao) {
          case 'PARALISADA_SUSPENSA':
            this.classProgress = 'is-warning'
            data.obraServico.icon = this.iconParalisada
            break;
          case 'CANCELADA':
          case 'RESCINDIDA':
          case 'FRACASSADA':
          case 'DESERTA':
          case 'REVOGADA':
          case 'ANULADA':
            this.classProgress = 'is-danger'
            data.obraServico.icon = this.iconCancelada
            break;
          case 'CONCLUIDA': 
            this.classProgress = 'is-success'
            data.obraServico.icon = this.iconConcluida
            break;
          case 'EM_PLANEJAMENTO':
          case 'AGUARDANDO_LICITACAO':
            this.classProgress = ''
            data.obraServico.icon = this.iconPlanejamento
            break;
          case 'AGUARDANDO_ORDEM_SERVICO':
          case 'EM_ANDAMENTO':
          default:
            this.classProgress = 'is-info'
            data.obraServico.icon = this.iconDefault;
        }
        return data.obraServico
      }"
      :debounce="500"
    >
      <template slot-scope="{ result: { loading, error, data } }">
      <!-- Loading -->
      <div v-if="loading">Carregando dados Obra...</div>

      <!-- Error -->
      <div v-else-if="error">{{ error.message }}</div>

      <!-- Result -->
      <div v-else-if="data">
        <table style="width: 100%">
          <tr v-if="showMap(data.latitude, data.longitude)">
            <td colspan="4">              
              <mapa :markers="[data]"
                    :zoom="17"
                    :popup="false">
              </mapa>
            </td>
          </tr>
          <tr><td><strong>Número da Obra</strong></td><td>{{data.numero}}</td><td></td>
            <td rowspan="8">
              <vue-qrcode :value="data.url"/>
            </td>
          </tr>
          <tr v-for="metadado in data.metadados" :key="metadado.name">
            <td v-if="metadado.value"><strong>{{metadado.name}}</strong></td>
            <td v-if="metadado.value" colspan="2">                        
              <div v-if="metadado.value.includes('https://')" style="white-space: nowrap">
                <b-button size="is-small" tag="a" 
                  target="_blank" :href="metadado.value">Link externo...</b-button>
              </div>
              <span v-else>{{metadado.value}}</span>
            </td>
          </tr>
          <tr><td><strong>Objeto</strong></td><td colspan="2">{{data.descricao}}</td></tr>
          <tr><td><strong>Contrato</strong></td><td><strong>CNPJ</strong></td><td><strong>Empresa</strong></td></tr>
          <tr><td>{{data.numero_contrato}}</td><td>{{data.cpf_cnpj}}</td><td>{{data.nome_contratado}}</td></tr>
          <tr><td><strong>Tipo</strong></td><td>{{data.tipo | formatEnumLabel}}</td></tr>
          <tr><td><strong>Localização</strong></td><td colspan="2">{{data.localizacao}}</td></tr>
          <tr><td><strong>Área / Volume</strong></td><td>{{data.quantidade ? data.quantidade + ' ' + data.descricao_unidade_medida : ''}}</td></tr>
          <tr><td><strong>Data Início</strong></td><td>{{data.data_inicio | formatDate}}</td></tr>
          <tr><td><strong>Previsão Término</strong></td><td>{{data.previsao_termino | formatDate}}</td></tr>
          <tr><td><strong>Situação da Obra</strong></td><td>{{data.situacaoDescricao}}</td></tr>
          <tr>
            <td><strong>REALIZADO</strong></td>
            <td colspan="2">
              <b-progress 
                :type="classProgress" 
                :max="1"
                :value="data.progresso" 
                size="is-large"
                :precision="2"
                :keep-trailing-zeroes="true"
                show-value 
                format="percent"></b-progress>
              <!-- {{data.progresso | numFormat('0.00%') }} -->
            </td>
            <td>
              <vue-blob-json-csv
                @success="handleSuccess"
                @error="handleError"
                file-type="json"
                :file-name="filename"
                :data="[data]"
              >
                <b-button 
                    size="is-small"
                    icon-left="file">JSON</b-button>
              </vue-blob-json-csv>
              <vue-blob-json-csv
                @success="handleSuccess"
                @error="handleError"
                file-type="csv"
                :file-name="filename"
                delimiter=","
                :data="[data]"
              >
                <b-button 
                    size="is-small"
                    icon-left="file-csv">CSV</b-button>
              </vue-blob-json-csv>
            </td>
          </tr>
          <!-- <tr><td><strong>Valor do contrato original</strong></td><td>{{data.valor_total | numFormat('$ 0,0.00') }}</td></tr> -->
          <tr><td><strong>Valor total dos contratos</strong></td><td>{{data.valor_total_contratos | numFormat('$ 0,0.00') }}</td></tr>
        </table>
        <b-tabs>
          <b-tab-item v-for="lote in data.lotes" 
              :key="lote.nome" 
              :label="data.lotes.length > 1 ? lote.nome : ''">
            <b-table :data="lote.contratos" :striped="true" :narrowed="true">
              <b-table-column field="numero_contrato" label="Contratos" v-slot="props">
                {{ props.row.numero_contrato }}
              </b-table-column>
              <b-table-column field="cpf_cnpj" label="CNPJ" v-slot="props">
                {{ props.row.cpf_cnpj }}
              </b-table-column>
              <b-table-column field="nome_contratado" label="Empresa" v-slot="props">
                {{ props.row.nome_contratado }}
              </b-table-column>
              <b-table-column field="responsavel_nome" label="Responsável" v-slot="props">
                {{ props.row.responsavel_nome }}
              </b-table-column>
              <b-table-column field="responsavel_documento" label="CREA/CAU" v-slot="props">
                {{ props.row.responsavel_documento }}
              </b-table-column>
              <b-table-column field="link" label="Planilhas" v-slot="props">
                <a :href="props.row.link" target="_blank">                  
                  <b-button 
                     size="is-small"
                     icon-left="file">XLSX</b-button>
                </a>
              </b-table-column>
            </b-table>
            <table style="width: 100%" v-if="data.lotes.length > 1">
              <tr><td><strong>Progresso do lote</strong></td></tr>
              <tr>
                <td>
                  <b-progress type="is-info" 
                    :max="1"
                    :value="lote.progresso" 
                    size="is-medium"
                    :precision="2"
                    :keep-trailing-zeroes="true"
                    show-value 
                    format="percent"></b-progress>
                </td>
              </tr>
            </table>
            <b-table :data="[...lote.situacoes, {totalMedicoes: true},{ totalContrato: true}]" 
                    :striped="true" :narrowed="true">
              <b-table-column field="descricao" label="Histórico" v-slot="props">
                  {{ props.row.descricao }}
              </b-table-column>
              <b-table-column field="data" label="Data" v-slot="props">
                <div v-if="props.row.totalMedicoes && lote.medicoes.length" style="white-space: nowrap">
                  <strong>Valor total de medições</strong>
                </div>
                <div v-else-if="props.row.totalContrato && lote.aditivos.length" style="white-space: nowrap">
                  <strong>Valor contrato atualizado</strong>
                </div>
                <div v-else>
                  {{ props.row.data | formatDate }}
                </div>
              </b-table-column>
              <b-table-column field="valorPago" label="Pagamentos"
                v-if="lote.medicoes.length" v-slot="props">
                <div v-if="props.row.totalMedicoes" style="white-space: nowrap">
                  <strong>
                    {{lote.pagamentos | numFormat('$ 0,0.00')}}
                    ({{ lote.progresso | numFormat('0.00%') }})
                  </strong>
                </div>
                <div v-else-if="props.row.valorPago" style="white-space: nowrap">
                  {{ props.row.valorPago | numFormat('$ 0,0.00') }}
                  ({{ getMedicao(lote, props.row.medicao).percentual | numFormat('0.00') }}%)
                </div>
              </b-table-column>
              <b-table-column field="valorAditivo" label="Valor Aditivo"
                v-if="lote.aditivos.length" v-slot="props">
                <div v-if="props.row.totalContrato" style="white-space: nowrap">
                  <strong>{{lote.valor_total | numFormat('$ 0,0.00')}}
                  </strong>
                </div>
                <div v-else-if="props.row.valorAditivo" style="white-space: nowrap">
                  {{ props.row.valorAditivo | numFormat('$ 0,0.00') }}
                </div>
              </b-table-column>
              <b-table-column field="link" label="" v-slot="props">
                <fotos v-bind="{entidade, all, ...getMedicao(lote, props.row.medicao)}"
                  v-if="props.row.medicao && getMedicao(lote, props.row.medicao).fotos && getMedicao(lote, props.row.medicao).fotos.length"></fotos>
                <fotos v-bind="{entidade, all, diario:true, ...getDiario(lote, props.row.diario)}"
                  v-if="props.row.diario && getDiario(lote, props.row.diario).fotos && getDiario(lote, props.row.diario).fotos.length"></fotos>  
                <a v-if="props.row.linkXlsx" :href="props.row.linkXlsx" target="_blank">                  
                  <b-button 
                     size="is-small"
                     icon-left="file">XLSX</b-button>
                </a>
                <div v-if="props.row.link" style="white-space: nowrap">
                  <b-button size="is-small" tag="a" 
                    target="_blank" :href="props.row.link">Mais informações...</b-button>
                </div>
              </b-table-column>
            </b-table>
            <!-- <b-table 
              :data="lote.medicoes" 
              :striped="true" 
              :narrowed="true"
              default-sort="data"
            >
              <b-table-column field="numero" label="Medições" v-slot="props">
                  {{ props.row.numero }}
              </b-table-column>
              <b-table-column field="data" label="Data" sortable="true" v-slot="props">
                  {{ props.row.data | formatDate }}
              </b-table-column>
              <b-table-column field="percentual" label="Percentual" v-slot="props">
                  {{ props.row.percentual | numFormat('0.00') }} %
              </b-table-column>
              <b-table-column field="valor_medicao" label="Valor" v-slot="props">
                  {{ props.row.valor_medicao | numFormat('$ 0,0.00') }}
              </b-table-column>
              <b-table-column field="fotos" label="Fotos" v-slot="props">
                <fotos v-bind="{entidade, ...props.row}"
                  v-if="props.row.fotos && props.row.fotos.length"></fotos>
              </b-table-column>
            </b-table> -->
          </b-tab-item>
        </b-tabs>
        <!-- <pre>
          {{
            data
          }}
        </pre> -->
      </div>

      <!-- No result -->
      <div v-else class="alert alert-warning">Carregando dados Obra...</div>
      </template>
    </ApolloQuery>
  </div>
</template>

<script>
import { icon } from "leaflet";
import VueQrcode from 'vue-qrcode';

export default {
  data() {
    return {
      fields: [
        { field: 'numero', label: 'Medições', },
        { field: 'data', label: 'Data' },
        { field: 'percentual', label: 'Percentual' },
        { field: 'valor_medicao', label: 'Valor' }
      ],
      classProgress: 'is-info',
      iconParalisada: icon({
        iconUrl: "marker-icon-paralisada.png",
        iconSize:[25, 41],      // Largura e altura do seu ícone
        iconAnchor: [12.5, 41],  // Metade da largura (centralizado) e total da altura (base do pino)
        popupAnchor: [0, -41] 
      }),
      iconCancelada: icon({
        iconUrl: "marker-icon-cancelada.png",
        iconSize:[25, 41],      // Largura e altura do seu ícone
        iconAnchor: [12.5, 41],  // Metade da largura (centralizado) e total da altura (base do pino)
        popupAnchor: [0, -41] 
      }),
      iconConcluida: icon({
        iconUrl: "marker-icon-concluida.png",
        iconSize:[25, 41],      // Largura e altura do seu ícone
        iconAnchor: [12.5, 41],  // Metade da largura (centralizado) e total da altura (base do pino)
        popupAnchor: [0, -41] 
      }),
      iconPlanejamento: icon({
        iconUrl: "marker-icon-planejamento.png",
        iconSize:[25, 41],      // Largura e altura do seu ícone
        iconAnchor: [12.5, 41],  // Metade da largura (centralizado) e total da altura (base do pino)
        popupAnchor: [0, -41] 
      }),
      iconDefault: icon({
        iconUrl: "marker-icon.png",
        iconSize:[25, 41],      // Largura e altura do seu ícone
        iconAnchor: [12.5, 41],  // Metade da largura (centralizado) e total da altura (base do pino)
        popupAnchor: [0, -41] 
      })
    };
  },
  props: {
    id: {
      default: 0,
      type: Number      
    },
    entidade: {
      default: 131,
      type: Number
    },
    all: {
      default: false,
      type: Boolean
    }
  },
  computed: {
    filename() {
      return 'obra_' + this.id
    },
    client() {
      return this.all ? 'v2' : 'v1'
    }
  },
  components: {
    Fotos: () => import('./Fotos.vue'),
    Mapa: () => import('./Mapa.vue'),
    VueQrcode,
  },
  methods: {
    handleSuccess() {

    },
    handleError() {

    },
    getMedicao (lote, medicaoId) {
      return lote.medicoes.filter(m => {
        return m.id == medicaoId
      })[0] || {}
    },
    getDiario (lote, diarioId) {
      return lote.diarios.filter(d => {
        return d.id == diarioId
      })[0] || {}
    },
    showMap(lat, lng) {
      return (lat && lng)
    }
  }
};
</script>